export default "__VITE_ASSET__dTfwpSZcOKfqCuGJosmokQ__"